import { Box, useTheme } from "@mui/material";

import MapSearch from "./MapSearch";
import MapViewControls from "./MapViewControls";
import OrthoZoomDebugMarker from "./OrthoZoomDebugMarker";
import PlotMapSidePanel from "./PlotMapSidePanel";

interface MapOverlayProps {}

const MapOverlay: React.FC<MapOverlayProps> = () => {
  const theme = useTheme();

  return (
    <Box
      aria-label="Map overlay"
      role="region"
      sx={{
        display: "flex",
        flexDirection: "row",
        inset: 0,
        pointerEvents: "none",
        position: "absolute",
        zIndex: 1,
      }}
    >
      <OrthoZoomDebugMarker />
      <Box
        sx={{
          left: theme.spacing(1),
          pointerEvents: "auto",
          position: "absolute",
          top: theme.spacing(1),
        }}
      >
        <MapSearch />
      </Box>
      <Box
        sx={{
          // Clear the Mapbox logo (required attribution) in the bottom-left.
          bottom: theme.spacing(5),
          left: theme.spacing(1),
          pointerEvents: "auto",
          position: "absolute",
        }}
      >
        <MapViewControls />
      </Box>
      <Box
        sx={{
          pointerEvents: "auto",
          position: "absolute",
          right: theme.spacing(1),
          top: theme.spacing(1),
        }}
      >
        <PlotMapSidePanel />
      </Box>
    </Box>
  );
};

export default MapOverlay;
